import { FC, useState } from 'react';

import { ToastContainer } from '@telialt/common-toast/src';

import { InitiateCheckoutProps } from '../../../hooks/useInitiateSelfServiceCheckout';
import { ServiceOfferItem } from '../../../model';
import { PlanOrderingFlowController } from '../../PlanCard';
import { PlanCardGrid } from '../../PlanCardGrid/PlanCardGrid';
import { PlansDescriptionModal } from './PlansDescriptionModal';
import { PlansDetailsModal } from './PlansDetailsModal';
import { ServiceOfferPlanCard } from './ServiceOfferPlanCard';

type Props = {
    items: ServiceOfferItem[];
    msisdn?: string;
    onSelectItem?: (service: ServiceOfferItem, index: number) => void;
    onSelectModifyService?: (service: ServiceOfferItem, index: number) => void;
    ctaLoadingUoId?: string;
    onCheckout?: (props: InitiateCheckoutProps) => void;
};

export const PlansList: FC<Props> = ({
    items,
    msisdn,
    onSelectItem,
    onSelectModifyService,
    ctaLoadingUoId,
    onCheckout,
}) => {
    const [isVASExpanded, setIsVASExpanded] = useState<boolean | undefined>(undefined);

    return (
        <>
            <PlanCardGrid>
                {items.map((item, index) => (
                    <ServiceOfferPlanCard
                        key={item.id}
                        serviceOffer={item}
                        msisdn={msisdn}
                        index={index}
                        onSelectItem={onSelectItem}
                        isVASExpanded={isVASExpanded}
                        onVASExpandChange={setIsVASExpanded}
                        ctaLoading={ctaLoadingUoId === item.uniqueOfferId}
                        ctaDisabled={!!ctaLoadingUoId}
                    />
                ))}
            </PlanCardGrid>
            <PlansDescriptionModal items={items} />
            <PlansDetailsModal items={items} />
            <PlanOrderingFlowController
                dataList={items.map((offer, index) => ({
                    uidForModal: offer.id,
                    planName: offer.name,
                    gifts: (offer.gifts?.items || []).map((gift) => ({
                        id: gift.id,
                        image: { src: gift.image, altText: gift.name },
                        oldPrice: gift.priceStandard,
                        price: gift.price,
                        title: gift.name,
                    })),
                    minimumGifts: offer.gifts?.minimumGifts,
                    giftsDescription: offer.gifts?.description,
                    giftsName: offer.gifts?.name,
                    commitmentType: offer.contractDuration,
                    hasTelia1: offer.isTeliaOne,
                    orderActionType: offer.orderActionType,
                    serviceType: offer.offerGroup,
                    serviceUoId: offer.uniqueOfferId,
                    teliaOneOfferId: offer.teliaOneOfferId,
                    offerSpecificationId: offer.offerSpecificationId,
                    code: offer.code,
                    nboId: offer.nboId,
                    pricing: { new: offer.priceFormatted, regular: offer.priceStandardFormatted },
                    gaTracking: {
                        source: 'publicServicePlanLeadModal',
                        data: {
                            plan: offer,
                            index,
                        },
                    },
                    onSelectModifyService: () => onSelectModifyService?.(offer, index),
                    offerGroup: offer.offerGroup,
                    nboElementPk: offer.nboElementPk,
                }))}
                onCheckout={onCheckout}
            />
            <ToastContainer />
        </>
    );
};
